import { Avatar, Box, Menu, Text, ResponsiveContext } from 'grommet'
import React from 'react'
import { AppContext } from '../libs/context'
import { Logout } from 'grommet-icons'
import { meshTheme } from '../libs/theme'

export const AuthUserMenu = ({ authUser, ...rest }) =>
  authUser && (
    <AppContext.Consumer>
      {({ actions, demoMode }) => (
        <ResponsiveContext.Consumer>
          {(size) => (
            <Menu
              label={
                size !== 'small' ? (
                  <Text truncate weight={'bold'}>
                    {authUser.displayName || authUser.email}
                  </Text>
                ) : (<Text truncate>{authUser.displayName.split(" ")[0]}</Text>)
              }
              icon={
                authUser.photoURL && (
                  <Box width={{ min: 'tiny' }} flex={false}>
                    <Avatar size="small" src={authUser.photoURL} />
                  </Box>
                )
              }
              items={[
                {
                  label: (
                    <Text weight="bold" color={demoMode ? 'status-warning' : 'light-6'}>
                      Demo Mode
                    </Text>
                  ),
                  size: 'large',
                  onClick: () => actions.setDemoMode(!demoMode)
                },
                {
                  label: (
                    <Text weight="bold" color={'light-6'}>
                      Log out
                    </Text>
                  ),
                  size: 'large',
                  onClick: actions.logout
                }
              ]}
              {...rest}
            />
          )}
        </ResponsiveContext.Consumer>
      )}
    </AppContext.Consumer>
  )
